import { BookingsReducerState } from './bookingsReducer.types';

export const BOOKINGS_REDUCER_INITIAL_STATE = Object.freeze<BookingsReducerState>({
    bookings: {},
    hasReceivedBookings: {},
    hasReceivedAllBookingsByUserId: {},
    hasReceivedAllBookingsByAssociationId: {},
});
